import type { DeadlineItem } from "@kollectivia/shared";

/** Quote deadlines are calendar dates, as in the shared delivery preview. */
export function formatDeadlineDate(
  item: Pick<DeadlineItem, "due_at" | "subject_kind">,
  lang: string,
): string {
  if (!item.due_at) return "";
  return new Intl.DateTimeFormat(lang === "en" ? "en-CA" : "fr-CA", {
    ...(item.subject_kind === "quote_request" ? { timeZone: "UTC" } : {}),
  }).format(new Date(item.due_at));
}
